// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1510":"c05cf09e","3995":"f03527e3","4449":"b4091d27","4881":"f03527e3","4919":"96fff69c"}[chunkId] + ".chunk.css";
};